export default "__VITE_ASSET__61ce6b5e__"